var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgUsers = function SvgUsers(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1663 24.5V22.1667C19.1663 20.929 18.6747 19.742 17.7995 18.8668C16.9243 17.9917 15.7374 17.5 14.4997 17.5H7.49967C6.262 17.5 5.07501 17.9917 4.19984 18.8668C3.32467 19.742 2.83301 20.929 2.83301 22.1667V24.5",
    stroke: "currentColor",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 12.8333C13.577 12.8333 15.6663 10.744 15.6663 8.16667C15.6663 5.58934 13.577 3.5 10.9997 3.5C8.42235 3.5 6.33301 5.58934 6.33301 8.16667C6.33301 10.744 8.42235 12.8333 10.9997 12.8333Z",
    stroke: "currentColor",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.167 24.5002V22.1669C26.1662 21.1329 25.8221 20.1284 25.1886 19.3112C24.5551 18.494 23.6681 17.9104 22.667 17.6519",
    stroke: "currentColor",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.167 3.65186C20.1708 3.90887 21.0605 4.49267 21.6959 5.31122C22.3313 6.12976 22.6761 7.13649 22.6761 8.17269C22.6761 9.20889 22.3313 10.2156 21.6959 11.0342C21.0605 11.8527 20.1708 12.4365 19.167 12.6935",
    stroke: "currentColor",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUsers);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;